import createUseTranslate from 'utils/createUseTranslate';

import en from './locales/en.json';
import nb from './locales/nb.json';

const useTranslate = createUseTranslate('search', en, nb);

export default useTranslate;
